import React, { Fragment } from "react";
import CopyRight from "src/Components/Custom/CopyRight/CopyRight";
import Footer from "src/Components/Custom/Footer/Footer";
import UserNavBar from "src/Components/Custom/UserNavBar/UserNavBar";
import FAQsContentEn from "./FAQsContentEn";
import FAQsContentFr from "./FAQsContentFr";
import FAQsContentAr from "./FAQsContentAr";
import { useTranslation } from "react-i18next";

function AuthFAQsPage() {
  const { i18n } = useTranslation();
  const lang = i18n.language;
  return (
    <Fragment>
      <UserNavBar />
      {lang ==='ar'? <FAQsContentAr/>:
      lang === 'fr' ? <FAQsContentFr /> : <FAQsContentEn />}
      <Footer />
      <CopyRight />
    </Fragment>
  );
}

export default AuthFAQsPage;
